const routes = {
  createBrand: 'brand',
  getBrands: 'brand',
  getBrandById: 'brand/',
  updateBrand: 'brand/',
  deleteBrand: 'brand/',
};

export default routes